import { createFileRoute } from '@tanstack/react-router';
import Wrapper from '../../../../components/Wrapper';
import { Input } from 'antd';
import { useState } from 'react';
import CModal from '../../../../components/CModal';
import { IconKey } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import { apiV1 } from '../../../../utils/apiClient';
import CopyText from '../../../../microcomponents/CopyText';
import PlanGate from '../../../../components/PlanGate';
import SettingsSection from '../../../../components/settings/SettingsSection';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  ArrowReloadHorizontalFreeIcons,
  DocumentCodeFreeIcons
} from '@hugeicons/core-free-icons';
import PageLoader from '../../../../microcomponents/PageLoader';
import * as React from 'react';
import TestEventsFeed from '../../../../components/developers/TestEventsFeed';
import WebhooksManager from '../../../../components/developers/WebhooksManager';
import { NButton } from '@next-is-free-monorepo/nif-web-components';

export const Route = createFileRoute('/_authenticated/settings/developers')({
  component: RouteComponent,
  pendingComponent: () => <PageLoader />
});

function RouteComponent() {

  const [apiKey, setApiKey] = useState<undefined | string>(undefined);

  const generateNewApiKey = useMutation({
    mutationFn: async () => {
      return await apiV1.post<string>('/shop/open-api/api-key', {});
    },
    onSuccess: (data) => setApiKey(data)
  });


  return (
    <div>
      <SettingsSection title={'Api keys'}
                       subtitle={'Genera una chiave privata per autenticare le richieste all\'api. Assicurati di mantenerla segreta.'}>
        <div>
          <PlanGate featureKey={'apiAccess'} hideMask>
            <div className={'flex gap-2'}>
              <Input disabled placeholder={'Api key'} value={'······························'} />
              <NButton size={'small'} onClick={() => generateNewApiKey.mutate()} loading={generateNewApiKey.isPending} hugeIcon={ArrowReloadHorizontalFreeIcons}>Ottieni Nuova</NButton>
            </div>
          </PlanGate>
        </div>

        <CModal width={440} title={'Nuova Api Key'} confirmButtonText={'ok'} hideConfirmButton
                cancelButtonText={'Chiudi'}
                open={!!apiKey} onClose={() => setApiKey(undefined)} icon={<IconKey />} color={'blue'}
                mutationOptions={{}}>
          <div>
            <CopyText text={apiKey || ''} label={'Api Key'} />
          </div>
        </CModal>
        <a href={'https://developers.nextisfree.io/'} target={'_blank'} rel={'noreferrer'}>
          <Wrapper>
            <div className={'flex items-center gap-2'}>
              <HugeiconsIcon icon={DocumentCodeFreeIcons} />
              <p>Documentazione Public Api</p>
            </div>
          </Wrapper>
        </a>
      </SettingsSection>
   {/*   <SettingsSection title={'Webhooks'}
                       subtitle={'Configura webhook per ricevere eventi in tempo reale dalla tua applicazione.'}>
        <div>
          <PlanGate featureKey={'apiAccess'} hideMask>
            <WebhooksManager />
          </PlanGate>
        </div>
      </SettingsSection>
      <SettingsSection title={'Eventi Test'}
                       subtitle={'Mostra gli eventi con il flag test_event_enabled impostato su true.'}>
        <div>
          <TestEventsFeed />
        </div>
      </SettingsSection>*/}
    </div>
  );
}
